import Defaults from 'superagent-defaults';

const API_URL = '';
const grant_type = 'password';
const PAGE_SIZE_MAX = 9999;

function authRequest(auth, token) {
  const superagent = new Defaults();

  if (auth) {
    if (token) {
      superagent.set('Authorization', `Bearer ${token}`);
    } else {
      superagent.set('Authorization', 'Basic YWRtaW5DbGllbnQ6');
    }
  }
  return superagent;
}

export const login = (username, password) =>
  authRequest(true).post(`${API_URL}/oauth/token`).type('form').send({ username, password, grant_type });

export const fetchUser = (userId, token) => authRequest(true, token).get(`${API_URL}/api/v1/users/${userId}`);

export const fetchCompanies = (token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/companies`);

export const fetchProjects = (companyId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v2/admin/companies/${companyId}/projects`);

export const fetchChats = (token) =>
  authRequest(true, token).get(`${API_URL}/api/v3/companies`).query({ size: 9999, page: 0, projectTypeGroup: 'CHATS' });

export const fetchChatStats = (projectId, from, to, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/chats/stats/${projectId}`).query({ from, to });

export const uploadFile = (value, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/storage`).attach('file', value);

export const fetchPdaList = (token) => authRequest(true, token).get(`${API_URL}/api/v1/data_sources/preferences`);

export const fetchOpportunities = (token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/opportunities/posts/`);

export const fetchOpportunity = (postId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/opportunities/posts/${postId}`);

export const updateOpportunity = (data, postId, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/admin/opportunities/posts/${postId}`).send(data);

export const createOpportunity = (value, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/admin/opportunities/posts`).send(value);

export const fetchCompany = (companyId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/companies/${companyId}`);

export const updateCompany = (data, sendEmail, token) =>
  authRequest(true, token).put(`${API_URL}/api/v1/admin/companies/${data.id}`).query({ sendEmail }).send(data);

export const deleteCompany = (companyId, token) =>
  authRequest(true, token).delete(`${API_URL}/api/v1/admin/companies/${companyId}`);

export const createCompany = (data, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/admin/companies`).send(data);

export const fetchResults = (pagination, filter, additionalQuery, token) => {
  return authRequest(true, token)
    .get(`${API_URL}/api/v2/admin/results`)
    .query({
      ...additionalQuery,
      size: pagination.size,
      page: pagination.page,
      freetext: filter,
      projectTypeGroup: 'ASSESSMENTS_V2',
      sort: 'simulation.createdAt,desc',
    });
};

export const fetchResult = (projectId, id, token) =>
  authRequest(true, token).get(`${API_URL}/api/v2/admin/results/${projectId}/${id}`);

export const fetchGameEvents = (gameId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/games/${gameId}/events`).query({ size: PAGE_SIZE_MAX });

export const fetchGameConversations = (gameId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/games/${gameId}/conversations`);

export const impersonateUser = (userId, apiClient, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/users/${userId}/impersonation`).query({ apiClient });

export const fetchAccountGroups = (token) => authRequest(true, token).get(`${API_URL}/api/v1/admin/accounts/groups`);

export const fetchAccountGroup = (groupId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/accounts/groups/${groupId}`);

export const createAccountGroup = ({ force, ...data }, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/admin/accounts/groups`).query({ force }).send(data);

export const updateAccountGroup = ({ force, ...data }, token) =>
  authRequest(true, token).put(`${API_URL}/api/v1/admin/accounts/groups/${data.id}`).query({ force }).send(data);

export const fetchAccountGroupIdByName = (value, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/accounts/groups/ids/by/name`).query({ value });

export const fetchUsers = (token) => authRequest(true, token).get(`${API_URL}/api/v1/admin/users`);

export const fetchTeams = (pagination, filter, additionalQuery, token) => {
  return authRequest(true, token)
    .get(`${API_URL}/api/v1/admin/teams`)
    .query({
      ...additionalQuery,
      size: pagination.size,
      page: pagination.page,
      name: filter,
      sort: 'name,asc',
    });
};

export const fetchTeam = (teamId, token) =>
  authRequest(true, token).get(`${API_URL}/api/v1/admin/teams/${teamId}`);

export const updateTeam = (data, token) =>
  authRequest(true, token).put(`${API_URL}/api/v1/admin/teams/${data.id}`).send(data);

export const createTeam = (data, token) =>
  authRequest(true, token).post(`${API_URL}/api/v1/admin/teams`).send(data);

export const deleteTeam = (teamId, token) =>
  authRequest(true, token).delete(`${API_URL}/api/v1/admin/teams/${teamId}`);



// WEBPACK FOOTER //
// ./src/services/Api.js